class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.dataset.uniqueboxid) {
        cartItems.removeBundleItems(this.dataset.uniqueboxid);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateMultipleItems(updateData) {
    //make POST request to change cart with updateData object
    $.ajax({
      type: 'POST',
      url: `${routes.cart_update_url}`,
      data: {
        updates: updateData,
      },
      dataType: 'json',
      success: function (cart) {
        window.location.reload();
      },
      error: function (err) {
        console.error('Update multiple items error: ', err);
      },
    });
  }

  clearCart() {
    $.ajax({
      type: 'POST',
      url: `${routes.cart_clear_url}`,
      dataType: 'json',
      success: (cart) => {
        window.location.reload();
      },
      error: (err) => {
        console.error('Clear cart error: ', err);
      },
    });
  }

  removeBundleItems(uniqueBoxId) {
    const updateData = [];
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      success: (cartData) => {
        //iterate through the properties of the items in cart. If the value (of key:value property) is === to the bundle_id value passed as an argument, then for that item, save item.key = 0
        const getItemsToUpdate = (updateData) => {
          for (var i = 0; i < cartData.items.length; i++) {
            var item = cartData.items[i];
            updateData[i] = cartData.items[i].quantity; //updates the quantities of the items in the cart at the start
            if (item.properties) {
              for (const [key, value] of Object.entries(item.properties)) {
                if (value === parseInt(uniqueBoxId)) {
                  this.enableLoading(i + 1);
                  updateData[i] = 0; //changes the quantity of the items in the cart at index i
                }
              }
            }
          }
          //check if all the items in the cart should be removed. If so, clear the cart
          const zeroCount = updateData.filter((item) => item === 0).length;
          if (zeroCount === updateData.length) {
            this.clearCart();
          }
          this.updateMultipleItems(updateData);
        };
        getItemsToUpdate(updateData);
      },
    });
  }

  updateQuantity(line, quantity) {
    this.enableLoading(line);

    const body = {
      line,
      quantity,
    };

    $.ajax({
      type: 'POST',
      url: `${routes.cart_change_url}`,
      data: body,
      dataType: 'json',
      success: function (cart) {
        window.location.reload();
      },
      error: function (err) {
        console.error('Update quantity error: ', err);
      },
    });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
